// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.howto-overlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  background: var(--palette-bg);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.howto {
  overflow: visible;
}

.howto__body {
  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);
}
.howto__sub {
  color: var(--palette-text-muted);
  margin-bottom: 20px;
}
.howto__board {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 7px;
  max-width: 206px;
  margin: 0 auto 8px;
}
.howto__board .tile {
  font-size: 1.1rem;
}
.howto__cap {
  text-align: center;
  font-size: 0.74rem;
  color: var(--palette-text-muted);
  margin-bottom: 24px;
}
.howto__cap b {
  color: var(--palette-primary);
}
.howto__step {
  display: flex;
  gap: 14px;
  padding: 14px 0;
  border-top: 1px solid var(--palette-border);
}
.howto__step-n {
  flex: 0 0 30px;
  height: 30px;
  border-radius: 50%;
  background: var(--palette-accent-soft);
  color: var(--palette-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-family: var(--font-display);
}
.howto__step-t {
  font-weight: 600;
  margin-bottom: 2px;
}
.howto__step-d {
  font-size: 0.9rem;
  color: var(--palette-text-muted);
}
.howto__cta {
  margin-top: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/helpPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;AACnC;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,mEAAmE;AACrE;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,2CAA2C;AAC7C;AACA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB","sourcesContent":[".howto-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 100;\n  background: var(--palette-bg);\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n.howto {\n  overflow: visible;\n}\n\n.howto__body {\n  padding: 0 var(--pad) calc(env(safe-area-inset-bottom, 0px) + 24px);\n}\n.howto__sub {\n  color: var(--palette-text-muted);\n  margin-bottom: 20px;\n}\n.howto__board {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 7px;\n  max-width: 206px;\n  margin: 0 auto 8px;\n}\n.howto__board .tile {\n  font-size: 1.1rem;\n}\n.howto__cap {\n  text-align: center;\n  font-size: 0.74rem;\n  color: var(--palette-text-muted);\n  margin-bottom: 24px;\n}\n.howto__cap b {\n  color: var(--palette-primary);\n}\n.howto__step {\n  display: flex;\n  gap: 14px;\n  padding: 14px 0;\n  border-top: 1px solid var(--palette-border);\n}\n.howto__step-n {\n  flex: 0 0 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: var(--palette-accent-soft);\n  color: var(--palette-primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-family: var(--font-display);\n}\n.howto__step-t {\n  font-weight: 600;\n  margin-bottom: 2px;\n}\n.howto__step-d {\n  font-size: 0.9rem;\n  color: var(--palette-text-muted);\n}\n.howto__cta {\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
